import { Skeleton } from 'ui';

function WebsiteWireframe() {
    return (
        <div className="w-full mx-auto">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200">
                <div className="bg-gray-100 p-2 border-b border-gray-200">
                    {/* Mini Header */}
                    <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-2">
                            <Skeleton className="h-2 w-8" />
                            <div className="flex gap-1">
                                <Skeleton className="h-1.5 w-4" />
                                <Skeleton className="h-1.5 w-5" />
                                <Skeleton className="h-1.5 w-4" />
                            </div>
                        </div>
                        <div className="flex items-center gap-1">
                            <Skeleton className="h-2 w-2 rounded-full" />
                            <Skeleton className="h-2 w-2 rounded-full" />
                        </div>
                    </div>
                </div>

                <div className="flex h-[480px] bg-gray-50">
                    {/* Mini Sidebar */}
                    <div className="w-12 bg-white border-r border-gray-200 p-1.5">
                        <Skeleton className="h-1.5 w-full mb-2" />
                        <div className="space-y-1">
                            <Skeleton className="h-1 w-full" />
                            <Skeleton className="h-1 w-4/5" />
                            <Skeleton className="h-1 w-full" />
                            <Skeleton className="h-1 w-3/4" />
                            <Skeleton className="h-1 w-full" />
                            <Skeleton className="h-1 w-5/6" />
                        </div>
                        <div className="mt-3 pt-2 border-t border-gray-100">
                            <Skeleton className="h-1 w-3/4" />
                            <Skeleton className="h-1 w-full mt-1" />
                            <Skeleton className="h-1 w-4/5 mt-1" />
                        </div>
                        <div className="mt-6">
                            <Skeleton className="h-1 w-full" />
                            <Skeleton className="h-1 w-3/4 mt-1" />
                            <Skeleton className="h-1 w-5/6 mt-1" />
                            <Skeleton className="h-1 w-full mt-1" />
                        </div>
                        <div className="mt-6">
                            <Skeleton className="h-1 w-2/3" />
                            <Skeleton className="h-1 w-full mt-1" />
                            <Skeleton className="h-1 w-4/5 mt-1" />
                        </div>
                    </div>

                    {/* Mini Main Content */}
                    <div className="flex-1 p-2 overflow-hidden">
                        {/* Page Header */}
                        <Skeleton className="h-2 w-16 mb-1" />
                        <Skeleton className="h-1 w-24 mb-3" />

                        {/* Mini Stats Cards */}
                        <div className="grid grid-cols-3 gap-1 mb-3">
                            {[...Array(3)].map((_, i) => (
                                <div key={i} className="bg-white p-1 rounded border border-gray-100">
                                    <Skeleton className="h-1 w-3/4 mb-0.5" />
                                    <Skeleton className="h-1.5 w-full" />
                                </div>
                            ))}
                        </div>

                        {/* Second row of stats */}
                        <div className="grid grid-cols-3 gap-1 mb-3">
                            {[...Array(3)].map((_, i) => (
                                <div key={i} className="bg-white p-1 rounded border border-gray-100">
                                    <Skeleton className="h-1 w-2/3 mb-0.5" />
                                    <Skeleton className="h-1.5 w-4/5" />
                                </div>
                            ))}
                        </div>

                        {/* Mini Chart Area */}
                        <div className="bg-white p-1.5 rounded border border-gray-100 mb-2">
                            <Skeleton className="h-1 w-8 mb-1" />
                            <Skeleton className="h-16 w-full" />
                        </div>

                        {/* Mini Table */}
                        <div className="bg-white p-1.5 rounded border border-gray-100 mb-2">
                            <Skeleton className="h-1.5 w-12 mb-1" />
                            <div className="space-y-0.5">
                                <div className="flex gap-1 pb-0.5 border-b border-gray-100">
                                    <Skeleton className="h-1 w-8" />
                                    <Skeleton className="h-1 w-10" />
                                    <Skeleton className="h-1 w-6" />
                                </div>
                                {[...Array(5)].map((_, i) => (
                                    <div key={i} className="flex gap-1 py-0.5">
                                        <Skeleton className="h-0.5 w-10" />
                                        <Skeleton className="h-0.5 w-12" />
                                        <Skeleton className="h-0.5 w-8" />
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Content Cards */}
                        <div className="grid grid-cols-2 gap-1 mb-2">
                            {[...Array(2)].map((_, i) => (
                                <div key={i} className="bg-white p-1.5 rounded border border-gray-100">
                                    <Skeleton className="h-1 w-8 mb-1" />
                                    <Skeleton className="h-8 w-full mb-1" />
                                    <Skeleton className="h-0.5 w-full" />
                                    <Skeleton className="h-0.5 w-4/5 mt-0.5" />
                                </div>
                            ))}
                        </div>

                        {/* Another Chart */}
                        <div className="bg-white p-1.5 rounded border border-gray-100 mb-2">
                            <div className="flex justify-between items-center mb-1">
                                <Skeleton className="h-1 w-10" />
                                <Skeleton className="h-1 w-6" />
                            </div>
                            <Skeleton className="h-12 w-full" />
                        </div>

                        {/* List Section */}
                        <div className="bg-white p-1.5 rounded border border-gray-100 mb-2">
                            <Skeleton className="h-1.5 w-14 mb-1" />
                            <div className="space-y-1">
                                {[...Array(4)].map((_, i) => (
                                    <div key={i} className="flex items-center gap-1">
                                        <Skeleton className="h-2 w-2 rounded" />
                                        <Skeleton className="h-0.5 w-20" />
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Gallery Grid */}
                        <div className="bg-white p-1.5 rounded border border-gray-100 mb-2">
                            <Skeleton className="h-1 w-10 mb-1" />
                            <div className="grid grid-cols-3 gap-0.5">
                                {[...Array(6)].map((_, i) => (
                                    <Skeleton key={i} className="h-8 w-full rounded" />
                                ))}
                            </div>
                        </div>

                        {/* Footer Actions */}
                        <div className="bg-white p-1.5 rounded border border-gray-100">
                            <div className="flex gap-1">
                                <Skeleton className="h-3 flex-1" />
                                <Skeleton className="h-3 flex-1" />
                            </div>
                        </div>
                    </div>

                    {/* Mini Right Sidebar */}
                    <div className="w-12 bg-white border-l border-gray-200 p-1.5">
                        <Skeleton className="h-1.5 w-full mb-2" />
                        <div className="space-y-1.5">
                            {[...Array(6)].map((_, i) => (
                                <div key={i} className="flex gap-0.5">
                                    <Skeleton className="h-1.5 w-1.5 rounded-full flex-shrink-0" />
                                    <Skeleton className="h-1 w-full" />
                                </div>
                            ))}
                        </div>
                        <div className="mt-3 pt-2 border-t border-gray-100">
                            <Skeleton className="h-1 w-full mb-1" />
                            <Skeleton className="h-2 w-full mb-1" />
                            <Skeleton className="h-2 w-full mb-1" />
                            <Skeleton className="h-2 w-4/5" />
                        </div>
                        <div className="mt-3 pt-2 border-t border-gray-100">
                            <Skeleton className="h-1 w-3/4 mb-1" />
                            {[...Array(4)].map((_, i) => (
                                <div key={i} className="mb-1.5">
                                    <Skeleton className="h-1 w-full" />
                                    <Skeleton className="h-0.5 w-3/4 mt-0.5" />
                                </div>
                            ))}
                        </div>
                        <div className="mt-3 pt-2 border-t border-gray-100">
                            <Skeleton className="h-1 w-full mb-1" />
                            <Skeleton className="h-6 w-full rounded" />
                            <Skeleton className="h-6 w-full rounded mt-1" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WebsiteWireframe